import SimpleSlider from 'components/pages/Private/Home/components/SimpleSlider';
import { useBanners } from 'hooks/useBanners';

export default function Banners() {
  const Banners = useBanners();

  return <SimpleSlider items={Banners} />;
}
